import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Truck } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const LogisticsCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-24 px-6 relative bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white">
          Move Freight Forward —
          <br />
          <span className="text-cyan-400">With Confidence</span>
        </h2>
        <p className="text-xl text-gray-300 mb-6 max-w-4xl mx-auto">
          Traain gives logistics and trucking organizations the Traaining, practice, and intelligence needed to operate safely, consistently, and at scale.
        </p>
        <p className="text-lg text-cyan-400 font-semibold italic mb-12">
          All aboard a more prepared, more aligned workforce.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={openCalendly}
            className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            data-testid="logistics-cta-demo-btn"
          >
            <Truck className="w-5 h-5 mr-2" />
            See Traain for Logistics & Trucking
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default LogisticsCTA;
